import VueCookies from 'vue-cookies';

export function cookiesPlugin() {
    return {
        $cookies: VueCookies
    }
}